import React, { type ComponentPropsWithoutRef, forwardRef } from "react";
import clsx from "clsx";
import styles from "./SpecsAndHighlights.module.scss";
import type { SpecGroupType } from "../../../hooks/useSpecs";
import Text from "../../../../shared-components/css-modules/lexus/atoms/Text";
import { useCarConfigSelector } from "../../../redux/store";
import { CarConfigLabel } from "../../../utils/labelUtils";
import type { SpecsNavigationItemType } from "../CarConfigBase";

type SpecsNavigationProps = ComponentPropsWithoutRef<"nav"> & {
    SpecsNavigationItems: SpecGroupType[] | SpecsNavigationItemType[];
    onSpecClick: (specId: string) => void;
};

const SpecsNavigation = forwardRef<HTMLElement, SpecsNavigationProps>(
    ({ SpecsNavigationItems, onSpecClick, className, ...restProps }, ref) => {
        const activeSection = useCarConfigSelector((state) => state.carConfigNavigation.activeSection);

        return (
            <nav ref={ref} className={clsx(styles.specsNavigation, className)} {...restProps}>
                <Text variant="apheleia-h2" tag="h2" className={styles.popoverTitle}>
                    <CarConfigLabel label="carConfigSpecsNavigationTitle" />
                </Text>
                <ul role="list">
                    {SpecsNavigationItems &&
                        SpecsNavigationItems.map((item) => (
                            <li key={item.id}>
                                <a
                                    href={`#${item.id}`}
                                    onClick={() => onSpecClick(item.id)}
                                    className={clsx(activeSection === item.id && styles.active)}
                                >
                                    <Text variant="apheleia-h6" tag="span">
                                        {item.name}
                                    </Text>
                                </a>
                            </li>
                        ))}
                </ul>
            </nav>
        );
    },
);

SpecsNavigation.displayName = "SpecsNavigation";

export default SpecsNavigation;
